import { MeterType, roundMeterValue } from "@next-platform/packages-ts-types";
/**
 * Snaps combined-rule thresholds that reference `meterId` to that meter's precision (whole steps on
 * bounded meters, `decimals` on number meters). Returns the same object when nothing changes.
 */
const snapRuleThresholdsToMeter = ({ definition, meterId }) => {
    const meter = definition.meters.find((candidate) => candidate.id === meterId);
    if (!meter || (meter.type !== MeterType.NUMBER && meter.type !== MeterType.BAR && meter.type !== MeterType.PIPS)) {
        return definition;
    }
    let hasChanged = false;
    const combinedRules = definition.combined_rules.map((rule) => ({
        ...rule,
        conditions: rule.conditions.map((condition) => {
            if (condition.meter_id !== meterId || condition.op === "tod_is" || condition.op === "day>=" || condition.op === "day<=") {
                return condition;
            }
            const snapped = meter.type === MeterType.NUMBER ? roundMeterValue(meter, condition.value) : Math.round(condition.value);
            if (snapped === condition.value) {
                return condition;
            }
            hasChanged = true;
            return { ...condition, value: snapped };
        }),
    }));
    return hasChanged ? { ...definition, combined_rules: combinedRules } : definition;
};
export default snapRuleThresholdsToMeter;
